import { Route } from '@vaadin/router'
import { container, Symbols } from '../di'
import { MeStore } from '../stores/me'
import { FeatureFlagsStore } from '../stores/featureFlags'

export type ViewRoute = Route & {
    title?: string
    icon?: string
    requiresLogin?: boolean
    children?: ViewRoute[]
}

const isAuthenticated = async () => {
    const meStore = container.get<MeStore>(Symbols.stores.me)
    await meStore.initialized
    return meStore.isAuthenticated
}

export const hasAccess = async (route: Route) => {
    const viewRoute = route as ViewRoute
    return viewRoute.requiresLogin ?
        await isAuthenticated() :
        true
}

const loginRedirect = async (context, command) => {
    if (!await hasAccess(context.route))
        return command.redirect('/login')
}

const nodesEnabled = async () => {
    const featureFlags = container.get<FeatureFlagsStore>(Symbols.stores.featureFlags)
    await featureFlags.initialized
    return featureFlags.flags.nodes
}

// Future /nodes view — redirects home until the server enables featureFlags.nodes.
// The kob-node-list component ships with EPIC 4.
const nodesRoute: ViewRoute = {
    path: '/nodes',
    component: 'kob-node-list',
    requiresLogin: true,
    icon: '',
    title: 'Nodes',
    action: async (context, command) => {
        if (!await nodesEnabled())
            return command.redirect('/')
        return loginRedirect(context, command)
    }
}

// place routes below (more info https://hilla.dev/docs/routing)
export const views: ViewRoute[] = [{
        path: '/',
        component: 'kob-book-list',
        requiresLogin: true,
        icon: '',
        title: 'Books',
        action: loginRedirect
    }, {
        path: '/devices',
        component: 'kob-device-list',
        requiresLogin: true,
        icon: '',
        title: 'Devices',
        action: loginRedirect
    }, {
        path: '/highlights',
        component: 'kob-highlight-list',
        requiresLogin: true,
        icon: '',
        action: loginRedirect
    }
]

export const routes: ViewRoute[] = [
    {
        path: '/login',
        component: 'kob-login',
        requiresLogin: false,
        icon: '',
        title: 'Login',
        action: async (_context, _command) => {
            if (await isAuthenticated())
                return _command.redirect('/')
            await import('../views/login')
        },
    }, {
        path: '/terms',
        component: 'kob-terms',
        icon: '',
        title: 'Terms of Use',
        requiresLogin: false,
    }, {
        path: '/privacy',
        component: 'kob-privacy',
        icon: '',
        title: 'Privacy Policy',
        requiresLogin: false,
    },
    {
        path: '/',
        component: 'kob-main',
        // nodesRoute is not in `views`, so it never shows a nav tab.
        children: [...views, nodesRoute],
    },
]